import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AdministartionService } from 'src/app/service/administartion.service';
import { formatDate } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';


@Component({
  selector: 'app-add-edit-compliance-management',
  templateUrl: './add-edit-compliance-management.component.html',
  styleUrls: ['./add-edit-compliance-management.component.scss']
})
export class AddEditComplianceManagementComponent implements OnInit {
  heading!: string;
  eventType: any;
  submitted = false
  displayRowData: any = [];
  errorMessage = '';
  isInvalid: boolean;

  constructor(public dialogRef: MatDialogRef<AddEditComplianceManagementComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private fb: FormBuilder, private service: AdministartionService, private constants: Constants, private ngxUiLoaderService: NgxUiLoaderService) {
    let userDeatails = JSON.parse(sessionStorage.getItem('userDetails')!)
  }
  addForm = this.fb.group({
    type: ['Route', [Validators.required]],
    category: ['', [Validators.required]],
    detail: ['', [Validators.required]],
    hhtDescription: ['', [Validators.required]],
    inactive: [false, [Validators.required]],
  })

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    if (this.eventType == 'Edit') {
      this.addForm.controls.type.setValue(this.dataStore.fullData.type)
      this.addForm.controls.category.setValue(this.dataStore.fullData.category)
      this.addForm.controls.detail.setValue(this.dataStore.fullData.detail)
      this.addForm.controls.hhtDescription.setValue(this.dataStore.fullData.hhtDescription)
      let status = this.dataStore.fullData.status == 'T' ? true : false;
      this.addForm.controls.inactive.setValue(status)
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.addForm.controls;
  }

  submitForm() {
    this.submitted = true
    // if ("") {
    //   this.isInvalid = true;
    //   return;
    // }
    // else {
    this.addEditCompliance();
    // }
  }

  onNoClick() {
    this.dialogRef.close({
      event: 'Noevent'
    })
  }

  status: boolean;
  addEditCompliance() {


    if (this.addForm.invalid) {
      this.ngxUiLoaderService.stop()

      return;
    }
    let obj;
    if (this.eventType == 'Edit') {
      obj = {
        configCells: [{
          id: this.dataStore.fullData.typeId,
          value: this.addForm.controls.type.value,
        },
        {
          id: this.dataStore.fullData.categoryId,
          value: this.addForm.controls.category.value,
        },
        {
          id: this.dataStore.fullData.detailId,
          value: this.addForm.controls.detail.value,
        },
        {
          id: this.dataStore.fullData.hhtDescriptionId,
          value: this.addForm.controls.hhtDescription.value,
        },
        {
          id: this.dataStore.fullData.statusId,
          value: this.addForm.controls.inactive.value ? "T" : "F",
        }],
        "configName": "supplierCompliance",
      }
    }
    else {
      obj = {
        "configProperties": [
          {
            "name": "new Row",
            "properties": [
              {
                "name": "type",
                value: this.addForm.controls.type.value,
              },
              {
                "name": "category",
                value: (this.addForm.controls.category.value)?.replace("'","''"),
              },
              {
                "name": "detail",
                value: (this.addForm.controls.detail.value)?.replace("'","''"),
              },
              {
                "name": "hhtDescription",
                value: (this.addForm.controls.hhtDescription.value)?.replace("'","''"),
              },
              {
                "name": "status",
                value: this.addForm.controls.inactive.value ? "T" : "F",
              }
            ]
          }
        ],
        "configName": "supplierCompliance",
      }
    }
    this.ngxUiLoaderService.start()
    this.service.updateConfigurationProperties(obj).subscribe({

      next: (res: any) => {
        this.ngxUiLoaderService.stop()

        if (res.status == 'SUCCESS') {
          this.dialogRef.close(
            {
              event: 'SaveEvent',
              eventData: this.addForm
            }
          );
        }
        else {
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
      },
      error: (err: any) => {
        this.errorMessage = this.constants.APIErrorMessage;
        this.ngxUiLoaderService.stop()

      }
    })
  }

  valSpecialChars(stringIn: any) {
    let fieldValid = true;
    let splChars = "*|,\":<>[]{}`\';()@&$#%./!^?\+= ";
    for (let i = 0; i < stringIn.length; i++) {
      if (splChars.indexOf(stringIn.charAt(i)) != -1) { fieldValid = false; }
    }
    return fieldValid;
  }

  dockdoor(event: any) {
    return this.valSpecialChars(event.key)
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData: any = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let test = this.valSpecialChars(pastedText);
    if (!test) {
      event.preventDefault();
    }
  }
}
